export interface UrlSorting {
  field: any
  direction: 'ASC' | 'DESC'
}

export interface SortingOption {
  label: string
  field?: string
  direction?: 'ASC' | 'DESC'
  chosen: boolean
}

export const getSortingOptions = (chosenSorting: UrlSorting | null) => {
  const options: SortingOption[] = [
    {
      label: 'Standard',
      field: undefined,
      direction: undefined,
      chosen: false,
    },
    { label: 'From A to Z', field: 'name', direction: 'ASC', chosen: false },
    { label: 'From Z to A', field: 'name', direction: 'DESC', chosen: false },
    {
      label: 'Price (low to high)',
      field: 'price',
      direction: 'ASC',
      chosen: false,
    },
    {
      label: 'Price (high to low)',
      field: 'price',
      direction: 'DESC',
      chosen: false,
    },
  ]

  let isChosenSet = false
  for (const option of options) {
    if (
      option.field === chosenSorting?.field &&
      option.direction === chosenSorting?.direction
    ) {
      option.chosen = true
      isChosenSet = true
      break
    }
  }
  if (!isChosenSet) {
    // options[0].chosen = true
  }
  return options
}

export const parseQuerySort = (query: string | null): UrlSorting | null => {
  if (!query) {
    return null
  }
  const [field, direction] = query.split('_')
  if (!field || !direction) {
    return null
  }
  const sorting: UrlSorting = {
    field: field,
    direction: direction as 'ASC' | 'DESC',
  }

  return sorting
}

export const serializeQuerySort = (value?: UrlSorting | null) => {
  if (value?.direction && value?.field) {
    return `${value.field}_${value.direction}`
  }
  return null
}
